
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { readCookie, removeCookie } from '@/tools/tools';
import {
  productTypeListPC,
  productTypeList,
  hotWordsList,
  hotWordsSelect,
  getSearchList,
  clearSingleSearchList,
  hotWordsSearchJson
} from '@/services/http';

@Component({
  name: 'Header'
})
export default class extends Vue {
  isDelete: boolean = false

  value: string = ''

  isLogin: boolean = false

  isShow: boolean = false

  ishistory: boolean = true

  showHistory: boolean = false

  isClassifyShow: boolean = false

  // whiteStauts: Object = {}

  productTypeId: number = 0

  // 导航第一个分类id
  firstProductId: string = ''

  // 分类列表
  productTypeList: [] = []

  hotWordsList: any[] = []

  searchList: any[] = [] // 历史记录

  // 分类列表子分类
  productTypeChildren: any[] = []

  shoppingList: any[] = []

  classifyIndex: number = 0

  currentIndex: number = -1

  isMenuShow: boolean = false

  indexServiceStr: any[] = []

  @Prop({ default: true }) private isClassifyBtn!: boolean

  @Prop({ default: false }) private isClassify!: boolean

  @Prop({ default: false }) private isFixed!: boolean

  @State('equipment') printerModelInfor: any

  @State('card') cardstate: any

  @State('white') whiteState: any

  @State('user') userinfor: any

  @State('notifys') notifysState: any

  @Action('notifys/messageSimple') messageSimple!: Function

  @Action('notifys/queryFirstBuy') queryFirstBuy!: Function

  async created() {
    if (this.$route.query.version || localStorage.getItem('isDlabel') === '1') {
      this.isShow = true;
      localStorage.setItem('isDlabel', '1');
    } else {
      localStorage.setItem('isDlabel', '0');
      this.isShow = false;
    }
    this.gethotWordsList();
    this.isLogin = !!readCookie('accessToken');
    this.value = this.$route.query.keyword ? String(this.$route.query.keyword) : '';
    // this.getProductTypeList()
    await this.queryFirstBuy();
    if (this.isLogin) {
      this.messageSimple();
    }
    this.isClassifyShow = this.isClassify;
    this.indexServiceStr = this.notifysState.serviceList.indexServiceStr.split(',');
  }

  mounted() {
  }

  handClose() {
    this.$router.push('/card');
  }

  hiddenFocus() {
    this.isDelete = false;
  }

  handTips() {
    this.$emit('handTips');
  }

  handClick() {
    // 将搜索词作为数据传递出去
    this.$emit('search-triggered');
  }

  hiddenBlur() {
    if (!this.isDelete) {
      this.showHistory = false;
    }
  }

  openShow() {
    this.showHistory = true;
    this.getSearch();
  }

  closeShowHistory() {
    if (!this.isDelete) {
      this.showHistory = false;
    }
  }

  handleCommand(command: string) {
    if (command === 'login') {
      const anchor = readCookie('anchor');
      if (anchor) {
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          (this as any).webTransport.getUserLoginData(JSON.stringify({}));
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify({}));
        } else {
          (window as any).JsIntrS.getUserLoginData({});
        }
      }
      removeCookie('accessToken');
      this.$router.push('/login');
    } else {
      this.$router.push('/user');
    }
  }

  // 比较版本
  compareVersion(v1: any, v2: any) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    // 调整两个版本号位数相同
    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);

      if (num1 > num2) {
        return 1;
      }
      if (num1 < num2) {
        return -1;
      }
    }

    return 0;
  }

  goback() {
    this.$router.back();
  }

  refresh() {
    window.location.reload();
  }

  goOrderList() {
    window.location.href = '/order-list';
  }

  async deleteSearch(id: string) {
    this.isDelete = true;
    setTimeout(() => {
      (this as any).$refs.hiddenInput.focus();
    }, 301);
    const res: any = await clearSingleSearchList({
      companyId: 1,
      searchId: id
    });
    if (res.data.code === 100) {
      this.getSearch();
    }
  }

  goMessage() {
    this.$router.push('/notifys');
  }

  private search() {
    hotWordsSearchJson({
      hotWord: this.value,
      channel: 0,
      companyId: 1
    });
    window.location.href = `/classify?keyword=${this.value}`;
  }

  async hotwordsSearch(item: any) {
    const res: any = await hotWordsSelect({
      id: item.id
    });
    if (res.data.code === 100) {
      window.location.href = `/classify?keyword=${item.keyword}`;
    }
  }

  // 最近搜索查询
  private async getSearch() {
    this.ishistory = !!readCookie('accessToken');
    if (this.ishistory) {
      const res: any = await getSearchList({
        companyId: 1
      });
      this.searchList = res.data.data;
    }
  }

  selectSearch(item: any) {
    this.value = item.keyword;
    window.location.href = `/classify?keyword=${this.value}`;
  }

  // 热门搜索
  async gethotWordsList() {
    const res: any = await hotWordsList({
      channel: 0,
      companyId: 1
    });
    this.hotWordsList = res.data.data;
  }

  dropdownClassify() {
    this.dropdownClick(Number(this.firstProductId), 0);
    this.currentIndex = 0;
    this.isClassifyShow = true;
    this.isMenuShow = true;
  }

  private async getProductTypeList() {
    const res: any = await productTypeListPC({
      companyId: 1
    });
    this.productTypeList = res.data.data.slice(0, 5);
    this.firstProductId = res.data.data[0] ? res.data.data[0].id : '';
  }

  private async dropdownClick(productTypeId: number, index: number) {
    this.currentIndex = index;
    this.productTypeId = productTypeId;
    const res: any = await productTypeList({
      productTypeId,
      companyId: 1
    });
    if (res.data.code === 100) {
      this.productTypeChildren = res.data.data.children;
      this.classifyIndex = this.productTypeChildren.length;
      this.isMenuShow = true;
    }
  }

  private goDetails(productTypeId: string, name: string) {
    window.location.href = `/classify?productTypeId=${productTypeId}&name=${name}`;
  }

  // 浏览更多
  watchMore() {
    this.$router.push(`/classify?parentTypeId=${this.productTypeId}`);
  }

  mouseLeave() {
    if (this.$route.name !== 'home') {
      this.isClassifyShow = false;
    }
    this.isMenuShow = false;
    this.currentIndex = -1;
  }
}
